import {GestionUsuario} from '../interfaces/gestion-usuarios.interace'

export const gestionUsuarioInitialState: GestionUsuario = {
  creacionUsuario: {
    formUser: {
      username: '',
      passwd: '',
      passwd2: '',
      birth_date: '',
      first_name: '',
      second_name: '',
      third_name: '',
      last_name: '',
      last_name2: '',
      last_name_married: '',
      nit: '',
      id_number: '',
      codigo_empresa: '',
      email: '',
      phone_number: '',
      location: '',
      role_access_user: '',
      description: '',
      username2: '',
      tipoDocumento: '',
      nombreTipoDocumento: '',
    },
    formError: {
      username: '',
      passwd: '',
      passwd2: '',
      birth_date: '',
      first_name: '',
      second_name: '',
      third_name: '',
      last_name: '',
      last_name2: '',
      last_name_married: '',
      nit: '',
      id_number: '',
      codigo_empresa: '',
      email: '',
      phone_number: '',
      location: '',
      role_access_user: '',
      description: '',
      tipoDocumento: '',
    },
    codeVerify: {
      code: '',
      error: '',
    },
    paginaActual: 0,
    modals: {
      activoConfirmacion: false,
      activoVerificacion: false,
      activoConfirmar: false,
      activoCreado: false,
    },
    catalogos: {
      sucursales: [],
    },
    sucursalesAsignadas: [],
    datosUsuarioCreado: null,
  },
  listarUsuarios: {
    arrayUsuarios: [],
    usuarios: [],
    formBuscar: {
      username: '',
      passwd: '',
      passwd2: '',
      birth_date: '',
      first_name: '',
      second_name: '',
      third_name: '',
      last_name: '',
      last_name2: '',
      last_name_married: '',
      nit: '',
      id_number: '',
      codigo_empresa: '',
      email: '',
      phone_number: '',
      location: '',
      role_access_user: '',
      description: '',
    },
    modales: {
      activeAceptarRechazar: false,
      activeSucursales: false,
      activeEliminar: false,
      activePassword: false,
      activePrint: false,
      activeEstatus: false,
    },
    catalogos: {
      sucursales: [],
    },
    sucursalesAsignadas: [],
    usuarioSeleccionado: null,
  },
  editarUsuario: {
    usuarioSeleccionado: null,
    formUser: {
      username: '',
      passwd: '',
      passwd2: '',
      birth_date: '',
      first_name: '',
      second_name: '',
      third_name: '',
      last_name: '',
      last_name2: '',
      last_name_married: '',
      nit: '',
      tipoDocumento: '',
      nombreTipoDocumento: '',
      id_number: '',
      codigo_empresa: '',
      email: '',
      phone_number: '',
      location: '',
      role_access_user: '',
      description: '',
    },
    formError: {
      username: '',
      passwd: '',
      passwd2: '',
      birth_date: '',
      first_name: '',
      second_name: '',
      third_name: '',
      last_name: '',
      last_name2: '',
      last_name_married: '',
      nit: '',
      tipoDocumento: '',
      nombreTipoDocumento: '',
      id_number: '',
      codigo_empresa: '',
      email: '',
      phone_number: '',
      location: '',
      role_access_user: '',
      description: '',
    },
    modales: {
      activeEliminar: false,
    },
  },
  estadoDocumentos: {
    arrayOriginalDocumentos: [],
    arrayFiltradoDocumentos: [],
    formBuscar: {
      username: '',
    },
    formCrear: {
      nombre: '',
      serie: '',
      codigo: '',
      descripcion: '',
    },
    formCrearError: {
      nombre: '',
      serie: '',
      codigo: '',
      descripcion: '',
    },
    modales: {
      activeCrearEditar: false,
      activeCrearEditarDoc: false,
      activeEliminar: false,
      activeEstatus: false,
    },
    documentoSeleccionado: null,
  },
  perfilUsuario: {
    nombre: '',
    apellido: '',
    correo: '',
    telefono: '',
    direccion: '',
    rol: 0,
    nit: '',
    facturas_maximas: 0,
    facturas_emitidas: 0,
    plan: '',
    precio: '',
    fecha_expiracion: '',
    type_id_number: '',
    id_number: '',
    sucursales: [],
  },
  sucursales: {
    dataSucursales: [],
    dataDocumentos: [],
    formSucursal: {
      idsucursal: '',
      mode: 'add',
      nombre: '',
      direccion: '',
      descripcion: '',
      codigo: '',
    },
    errorsSucursal: {
      idsucursal: '',
      mode: 'add',
      nombre: '',
      direccion: '',
      descripcion: '',
      codigo: '',
    },
    formDocumento: {
      mode: 'add',
      idsucursal: '',
      documento: '',
      serie: '',
      correlativoInicial: '0',
      correlativoFinal: '0',
      resolucion: '',
      numeroSucursal: '',
      codigoSucursal: '',
    },
    errorsDocumento: {
      mode: 'add',
      idsucursal: '',
      documento: '',
      serie: '',
      correlativoInicial: '',
      correlativoFinal: '',
      resolucion: '',
      numeroSucursal: '',
      codigoSucursal: '',
    },
  },
}
